<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="recipe.id === null">{{ 'NEWRECIPE' | translate }}</span>
            <span *ngIf="recipe.id !== null">{{ 'EDITRECIPE' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="recipeForm" id="recipeForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="recipeForm" >
            <input type="hidden" name="id" id="recipeId" formControlName="id" />
            <div class="p-fluid p-grid">
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <h2>{{ 'RECIPE' | translate }}</h2>
              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="recipeTitle" formControlName="title" type="text" pInputText [required]="true"> 
                      <label for="recipeTitle" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="recipeForm.controls['title'].invalid && (recipeForm.controls['title'].dirty || recipeForm.controls['title'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="recipeForm.controls['title'].errors !== null">
                  <div *ngIf="recipeForm.controls['title'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="recipeTitleAr" formControlName="titleAr" type="text" pInputText [required]="false"> 
                      <label for="recipeTitleAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="recipeTitleFr" formControlName="titleFr" type="text" pInputText [required]="false"> 
                      <label for="recipeTitleFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>

                    <input type="file"  pButton pRipple icon="pi pi-folder" styleClass="p-button-info"  class="w-100" (change)="uploadPhoto($event)" accept="image/*" />
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-alarm-clock"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="recipeduration" formControlName="duration" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="recipeduration" class="">{{ 'duration' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-alarm-clock"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="recipecarbs" formControlName="carbs" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="recipecarbs" class="">{{ 'carbs' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
          
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-alarm-clock"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="recipecalories" formControlName="calories" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="recipecalories" class="">{{ 'calories' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-alarm-clock"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="recipeproteins" formControlName="proteins" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="recipeproteins" class="">{{ 'proteins' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
           
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-info-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="recipeDescription" formControlName="description" type="text" pInputText [required]="true"> 
                      <label for="recipeDescription" class="req">{{ 'DESCRIPTION' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="recipeForm.controls['description'].invalid && (recipeForm.controls['description'].dirty || recipeForm.controls['description'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="recipeForm.controls['description'].errors !== null">
                  <div *ngIf="recipeForm.controls['description'].errors.required">
                   {{ 'DESCRIPTIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-align-justify"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="recipeDescriptionAr" formControlName="descriptionAr" type="text" pInputText [required]="false"> 
                      <label for="recipeDescriptionAr" class="">{{ 'DESCRIPTIONAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-align-justify"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="recipeDescriptionFr" formControlName="descriptionFr" type="text" pInputText [required]="false"> 
                      <label for="recipeDescriptionFr" class="">{{ 'DESCRIPTIONFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-folder"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="recipeCategoryId" [autoDisplayFirst]="false" formControlName="category" [options]="categories" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="recipeCategoryId" class="req">{{ 'CATEGORY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="recipeForm.controls['category'].invalid && (recipeForm.controls['category'].dirty || recipeForm.controls['category'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="recipeForm.controls['category'].errors !== null">
                  <div *ngIf="recipeForm.controls['category'].errors.required">
                   {{ 'CATEGORYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <!-- 
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-folder"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="applicationId" [autoDisplayFirst]="false" formControlName="subCategory" [options]="recipesColumnsService.subCategories" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="applicationId" class="req">{{ 'application' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="recipeForm.controls['subCategory'].invalid && (recipeForm.controls['subCategory'].dirty || recipeForm.controls['subCategory'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="recipeForm.controls['subCategory'].errors !== null">
                  <div *ngIf="recipeForm.controls['subCategory'].errors.required">
                   {{ 'SUBCATEGORYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div> -->
              <!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <!-- <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="recipeSlug" formControlName="slug" type="text" pInputText [required]="true"> 
                      <label for="recipeSlug" class="req">{{ 'SLUG' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="recipeForm.controls['slug'].invalid && (recipeForm.controls['slug'].dirty || recipeForm.controls['slug'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="recipeForm.controls['slug'].errors !== null">
                  <div *ngIf="recipeForm.controls['slug'].errors.required">
                   {{ 'SLUGREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div>
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="recipeSlugAr" formControlName="slugAr" type="text" pInputText [required]="false"> 
                      <label for="recipeSlugAr" class="">{{ 'SLUGAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
            </div>
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="recipeSlugFr" formControlName="slugFr" type="text" pInputText [required]="false"> 
                      <label for="recipeSlugFr" class="">{{ 'SLUGFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
            </div> -->
            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown inputId="applicationId" [autoDisplayFirst]="false" formControlName="application" [options]="applications"
                        (onChange)="onChange($event)" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="applicationId" class="req">{{ 'Application' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div
                  *ngIf="recipeForm.controls['application'].invalid && (recipeForm.controls['application'].dirty || recipeForm.controls['application'].touched)"
                  class="alert alert-danger">
                  <ng-container *ngIf="recipeForm.controls['application'].errors !== null">
                    <div *ngIf="recipeForm.controls['application'].errors.required">
                      {{ 'VALIDATION.APPLICATIONREQUIRED' | translate }}.
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKRECIPES' | translate }}</span>
                </button>
              </div>
          
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!recipeForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

